if(!customElements.get('dialog-modal')) {   
    customElements.define('dialog-modal', class extends HTMLElement {
        constructor() {
            super();
            this.elements = {
                button: this.querySelector('button'),
                panel: this.querySelector('.content'),
                closeButton: this.querySelector('.modal__close-button')
            };
        }
        connectedCallback() {
            this.elements.button.addEventListener('click', this.openSelector.bind(this));
            if(this.elements.closeButton) {
                this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
            }
            this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        }

        openSelector() {
            this.elements.button.focus();
            this.elements.panel.classList.toggle('menu-hidden');
            this.elements.button.setAttribute(
                'aria-expanded',
                (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
            );
        }

        closeSelector(event) {
            const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
            if (event.relatedTarget === null || shouldClose) {
                this.hidePanel();
            }
        }
        hidePanel() {
            this.elements.panel.classList.add('menu-hidden');
            this.elements.button.setAttribute('aria-expanded', 'false');
        }
    });
}